import {
  CreditCard02,
  Lightning01,
  MessageAlertCircle,
  SwitchHorizontal02,
} from '@branch-messenger/willow-ui/icons'

import { IconListProps } from '@/components/icon-list/types'
import { useOrg } from '@/selectors/organization'

export const useAppFeaturesList = () => {
  const {
    data: { orgName },
  } = useOrg()

  const appFeaturesList: IconListProps['items'] = [
    {
      header: 'Free, fast, & secure payments',
      description: `Get your ${orgName} payouts directly in your Branch account—no waiting, no hassle.*`,
      icon: Lightning01,
    },
    {
      header: 'No existing debit card or bank account needed',
      description:
        'Access your funds quickly without needing a pre-existing bank account or debit card.',
      icon: CreditCard02,
    },
    {
      header: 'Financial wellness tools',
      description:
        'Cash flow management tools and financial wellness features that can help you manage your money.',
      icon: MessageAlertCircle,
    },
    {
      header: 'Easy ways to spend & save',
      description:
        'Use your funds right with the Branch Card or transfer to another account where eligible.*',
      icon: SwitchHorizontal02,
    },
  ]

  return appFeaturesList
}
